import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgxDaterangepickerBootstrapModule } from 'ngx-daterangepicker-bootstrap';

import { RangeDatePickerComponent } from './range-date-picker.component';

@NgModule({
  declarations: [RangeDatePickerComponent],
  imports: [CommonModule, FormsModule, MatIconModule, NgxDaterangepickerBootstrapModule],
  exports: [RangeDatePickerComponent],
})
export class RangeDatePickerModule {}
